import { SwitchProps } from "antd";
import { StyledSwitch } from "./atom";

export function Switch({ className = "", ...props }: SwitchProps) {
  return (
    <StyledSwitch className={`renderbus-ui--switch ${className}`} {...props} />
  );
}
